/* @flow */
/* eslint-disable no-shadow, no-unused-vars */

import React from 'react';
import ExternalLinkIcon from 'components/icons/ExternalLinkIcon';

import type { ExternalLinkProps } from './types';

const ExternalLink = ({
  arias = {},
  children,
  hasArrowIcon = true,
  href,
  style,
  title = "",
  customDataTestID,
}: ExternalLinkProps): React.Element => (
  <a
    {...arias}
    href={href}
    rel="noopener noreferrer"
    style={style}
    target="_blank"
    title={title}
    data-testid={customDataTestID}
    >
    {hasArrowIcon && <ExternalLinkIcon style={{ fontSize: '1rem' }} />}
    {children}
  </a>
);

export default ExternalLink;
